import { DateTime } from 'luxon';

export const today = {
  from: DateTime.now().startOf('day').toJSDate(),
  to: DateTime.now().endOf('day').toJSDate(),
};

export const yesterday = {
  from: DateTime.now().minus({ days: 1 }).startOf('day').toJSDate(),
  to: DateTime.now().minus({ days: 1 }).endOf('day').toJSDate(),
};

export const thisWeek = {
  from: DateTime.now().startOf('week').toJSDate(),
  to: DateTime.now().endOf('week').toJSDate(),
};

export const previousWeek = {
  from: DateTime.now().minus({ weeks: 1 }).startOf('week').toJSDate(),
  to: DateTime.now().minus({ weeks: 1 }).endOf('week').toJSDate(),
};

export const thisMonth = {
  from: DateTime.now().startOf('month').toJSDate(),
  to: DateTime.now().endOf('month').toJSDate(),
};

export const previousMonth = {
  from: DateTime.now().minus({ months: 1 }).startOf('month').toJSDate(),
  to: DateTime.now().minus({ months: 1 }).endOf('month').toJSDate(),
};

export const thisYear = {
  from: DateTime.now().startOf('year').toJSDate(),
  to: DateTime.now().endOf('year').toJSDate(),
};

export const previousYear = {
  from: DateTime.now().minus({ years: 1 }).startOf('year').toJSDate(),
  to: DateTime.now().minus({ years: 1 }).endOf('year').toJSDate(),
};

export const dateTimeRanges = [
  {
    label: 'TODAY',
    value: today,
  },
  {
    label: 'YESTERDAY',
    value: yesterday,
  },
  {
    label: 'THIS_WEEK',
    value: thisWeek,
  },
  {
    label: 'PREVIOUS_WEEK',
    value: previousWeek,
  },
  {
    label: 'THIS_MONTH',
    value: thisMonth,
  },
  {
    label: 'PREVIOUS_MONTH',
    value: previousMonth,
  },
  {
    label: 'THIS_YEAR',
    value: thisYear,
  },
  {
    label: 'PREVIOUS_YEAR',
    value: previousYear,
    display: 'YEAR_DISPLAY',
    formatParams: { date: { year: 'numeric' } },
  },
];
